<template>
  <div class="footer">
    <div class="footer-content mb-4">
      <div class="logo">
        <logo-footer class="footer-logo"/>
        <button class="button" @click="$router.push('/services')">Записаться <under-arrow/></button>
        <div class="mt-24">
          <a class="favorite-link" href="https://www.youtube.com/channel/UCbMgwAs663J_8FcBdWimtKg" target="_blank"><Youtube :fill="'#7E7E7E'"/></a>
          <a class="favorite-link" href="https://www.instagram.com/psiholog_rambelli/" target="_blank"><Instagram :fill="'#7E7E7E'" class="ml-4"/></a>
        </div>
      </div>
      <div class="links d-flex">
        <div class="nav-links mr-120">
          <p class="links-title">Ссылки</p>
          <router-link to="/services" class="link">Услуги</router-link>
          <router-link to="/about" class="link">Обо мне</router-link>
          <router-link to="/stories" class="link">Статьи</router-link>
          <router-link to="/video" class="link">Видео</router-link>
        </div>
        <div class="nav-links">
          <p class="links-title">Контакты:</p>
          <a href="mailto:svetlanarambelli@gmail.com" class="link"><mail/>svetlanarambelli@gmail.com</a>
          <a href="https://wa.me/393200946598" target="_blank" class="link"><Whatsapp/><span class="numbers"><u><span class="Raleway">+</span>393200946598</u></span></a>
          <a href="viber://chat?number=393200946598" class="link"><viber/><span class="numbers"><u><span class="Raleway">+</span>393200946598</u></span></a>
        </div>
      </div>
    </div>
   <div class="d-flex flex-wrap justify-content-start">
     <p class="policy w-100" @click="$router.push('/policy')">Политика конфиденциальности</p>
     <p class="copy w-100"><span>© Светлана Рамбелли.</span> <span>All rights reserved.</span></p>
   </div>
  </div>
</template>

<script>
  import LogoFooter from '@/components/icons/LogoFooter';
  import UnderArrow from '@/components/icons/UnderArrow';
  import Youtube from '@/components/icons/Youtube';
  import Instagram from '@/components/icons/Instagram';
  import Viber from '@/components/icons/Viber2';
  import Mail from '@/components/icons/Mail';
  import Whatsapp from '@/components/icons/Whatsapp';

  export default {
    name: "Footer",
    components: {LogoFooter, UnderArrow, Youtube, Instagram, Viber, Mail, Whatsapp}
  }
</script>

<style lang="scss">
  .mr-120 {
    margin-right: 120px
  }
  .footer {
    padding: 100px 24px 54px;
    font-variant-numeric: lining-nums;
    font-family: 'Raleway', sans-serif;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    &-content {
      justify-content: space-between;
      display: flex;
     .logo {
       display: flex;
       flex-wrap: wrap;
       max-width: 181px;
       .footer-logo {
         width: 153px;
       }
       .button {
         width: 181px;
         height: 48px;
         border-radius: 9px;
         background-color: #5ec8f5;
         border: none;
         color: #fff;
         margin-top: 24px;
         svg {
           transform: rotate(-90deg);
           margin-left: 16px;
         }
       }
     }
      .links {
        .nav-links {
          .links-title {
            font-size: 17px;
            color: #1f1f1f;
            margin: 0;
            line-height: 1;
          }
          .link {
            font-size: 17px;
            color: #7e7e7e;
            display: block;
            margin-top: 16px;
            svg {
              margin-right: 16px;
            }
          }
        }
      }
    }
    .policy {
      font-size: 12px;
      color: #7e7e7e;
      margin: 0;
      text-decoration: underline;
      cursor: pointer;
    }
    .copy {
      font-size: 12px;
      text-align: left;
      line-height: 1.48;
      color: #7e7e7e;
      margin: 32px 0 0 0;
    }
  }
  @media screen and (max-width: 750px){
    .footer {
      &-content {
        .links {
          .nav-links:nth-child(1) {
            display: none;
          }
        }
      }
      .policy {
        text-align: center;
        margin-bottom: 24px;
      }
      .copy {
        margin-top: 24px;
        display: flex;
        flex-wrap: wrap;
        text-align: center;
        span {
          width: 100%;
        }
      }
    }
  }
  @media screen and (max-width: 550px){
    .footer {
      padding: 64px 24px;
      &-content {
        flex-wrap: wrap-reverse;
        .logo {
          width: 100%;
          margin-left: auto;
          margin-right: auto;
          .footer-logo {
            margin-left: auto;
            margin-right: auto;
          }
          div {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: auto;
            margin-right: auto;
          }
        }
        .links {
          justify-content: center;
          width: 100%;
          text-align: center;
          margin-bottom: 64px;
          .nav-links {
            width: auto;
          }
        }
      }
      .policy {
        text-align: center;
      }
    }
  }
</style>